// eslint-disable-next-line
__webpack_public_path__ = window.WEBPACK_PUBLIC_PATH;
export default undefined;
